export default class Artist{
    constructor(id, name, url, uri){
        this.id = id;
        this.name = name;
        this.url = url;
        this.uri = uri;
    }
}